import React from "react";
import MainSection6 from "../../components/Main/MainSection6";
import { Responsive } from "../../interface/redux/config";

type Props = {
  PcTablet: Responsive;
  Mobile: Responsive;
};

const Contact = ({ PcTablet, Mobile }: Props) => {
  return (
    <>
      <PcTablet>
        <main
          className="flex items-center bg-black mb:h-screen"
          style={{ height: "calc(100% - 314px)" }}
        >
          <MainSection6 extraClass="justify-center" />
        </main>
      </PcTablet>
      <Mobile>
        <main className="flex items-center h-full bg-black">
          <MainSection6 extraClass="justify-center" />
        </main>
      </Mobile>
    </>
  );
};

export default Contact;
